import {Component, OnInit} from '@angular/core';
import {SpecialCompbaser} from "../../../components/compbaser";
import {ActivatedRoute, ChildrenOutletContexts, Router} from "@angular/router";
import {EnumStudioType, IPlayerProps} from "../../../interfaces";
import {animate, style, transition, trigger} from '@angular/animations';
import {isNullOrUndefOrEmpty} from "../../../common";
import {StoreSelectorsService} from "../../../services";
import {Memoizee} from "../../../decorators/memoizee-decorator";

@Component({
    selector: 'app-scene-list',
    templateUrl: './scene-list.component.html',
    styleUrls: ['./scene-list.component.scss'],
    animations: [
        trigger('fadeIn', [
            transition('* => *', [
                style({ opacity: 0 }),
                animate('300ms ease-in-out')
            ])
        ])
    ],
    standalone: false
})

export class SceneListComponent extends SpecialCompbaser implements OnInit {
    scenes: IPlayerProps[] = [];
    loading = true;
    studioType: EnumStudioType;
    EnumStudioType = EnumStudioType;

    constructor(private storeSelector: StoreSelectorsService, private activatedRoute: ActivatedRoute, public router: Router, private contexts: ChildrenOutletContexts) {
        super();
    }

    ngOnInit() {
        this.cod(
            this.storeSelector.getUser().subscribe((i_user) => {
                this.studioType = i_user.studioType;
            })
        );
        this.cod(
            this.storeSelector.getOS().subscribe((i_os) => {
                if (i_os.family !== 'Windows') {
                }
            })
        );
        this.cod(
            this.activatedRoute.paramMap.subscribe((routeParams) => {
                const autoLoadSceneId = routeParams.get('id');
                if (!isNullOrUndefOrEmpty(autoLoadSceneId))
                    this.router.navigateByUrl(`/editor/scene/${autoLoadSceneId}`);
            })
        );
    }
    
    @Memoizee({})
    getState() {
        return this.contexts.getContext('primary')?.route?.snapshot?.data?.['state'];
    }
}
